import type { UserRole } from '@plane/shared';
import { Link, Outlet } from 'react-router-dom';

import { useAuth } from '@/modules/auth/hooks/auth-context';

/**
 * Barreira por papel, dentro de `ProtectedRoute`.
 *
 * Mostrar uma explicação é melhor do que redirecionar em silêncio: quem chegou
 * por um link direto precisa entender que a conta não tem permissão, e não
 * achar que a página sumiu.
 *
 * Isto é conveniência de navegação, não segurança. A API recusa de qualquer
 * forma — nenhuma decisão de autorização depende deste componente.
 */
export function RequireRole({ papeis }: { papeis: readonly UserRole[] }) {
  const { usuario } = useAuth();

  if (usuario && !papeis.includes(usuario.role)) {
    return (
      <div className="flex max-w-lg flex-col gap-3">
        <h1 className="font-display text-2xl">Sem permissão</h1>
        <p className="text-sm text-ink-soft">
          Esta área é restrita a administradores. Se você precisa de acesso, peça a quem administra
          o painel.
        </p>
        <Link to="/" className="text-sm text-brand-700 underline">
          Voltar à visão geral
        </Link>
      </div>
    );
  }

  return <Outlet />;
}
